import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'product-grid-item',
  templateUrl: './product-grid-item.component.html',
  styleUrls: ['./product-grid-item.component.scss'],
})
export class ProductGridItemComponent implements OnInit {
  @Input() itemData: any;
  constructor() {}

  ngOnInit() {}
}
